'use client';

import React, { useMemo, useState } from 'react';
import { Map, AdvancedMarker, InfoWindow } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import SearchMapMarker from './SearchMapMarker';

const DEFAULT_MAP_OPTIONS = {
    zoom: 8,
    center: { lat: 51.3, lng: -0.3 },
    options: {
        disableDefaultUI: true,
        clickableIcons: false,
        zoomControl: true,
    },
    mapId: 'citydoc-booking-journey',
};

SearchMap.propTypes = {
    selectedAddress: PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    results: PropTypes.array.isRequired,
    curTab: PropTypes.string,
    onSelect: PropTypes.func,
};

export default function SearchMap({ selectedAddress, results, curTab, onSelect }) {
    const mapOptions = useMemo(() => DEFAULT_MAP_OPTIONS.options, []);
    const [infowindowOpen, setInfowindowOpen] = useState(false);
    const [activeMarker, setActiveInfoMarker] = useState(null);
    const [activeResult, setActiveResult] = useState(null);

    const onMarkerSelect = (marker, result) => {
        setInfowindowOpen(true);
        setActiveInfoMarker(marker);
        setActiveResult(result);
    };

    const onCloseMarker = () => {
        setInfowindowOpen(false);
        setActiveInfoMarker(null);
        setActiveResult(null);
    };

    const selectResult = (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('select-clinic', {detail: activeResult}));
        onSelect(activeResult);
    };

    return (
        <div className={`searchMapWrapper ${curTab == 'map' ? 'searchMapWrapper--active' : ''}`}>
            <div className="map-container">
                <Map
                    defaultZoom={DEFAULT_MAP_OPTIONS.zoom}
                    defaultCenter={DEFAULT_MAP_OPTIONS.center}
                    className="searchMapWrapper__map"
                    options={mapOptions}
                    mapId={DEFAULT_MAP_OPTIONS.mapId}
                >
                    {Object.keys(selectedAddress).length && (
                        <AdvancedMarker
                            position={{
                                lat: selectedAddress.lat,
                                lng: selectedAddress.lng,
                            }}
                        />
                    )}
                    {results.map((result) => (
                        <SearchMapMarker
                            key={result.id}
                            data={result}
                            onMarkerSelect={onMarkerSelect}
                        />
                    ))}
                    {infowindowOpen && activeResult && (
                        <InfoWindow
                            anchor={activeMarker}
                            maxWidth={250}
                            onCloseClick={onCloseMarker}
                            className="infoWindow"
                        >
                            <h4
                                className="infoWindow__title"
                                dangerouslySetInnerHTML={{
                                    __html: activeResult.title,
                                }}
                            ></h4>
                            <address
                                className="infoWindow__address"
                                dangerouslySetInnerHTML={{
                                    __html: activeResult.address.replace(
                                        /[<]br[^>]*[>]/gi,
                                        ''
                                    ),
                                }}
                            ></address>
                            <p className="infoWindow__directions">
                                <a
                                    target={'_blank'}
                                    href={`https://www.google.com/maps?saddr=${encodeURI(
                                        selectedAddress?.address
                                    )}&daddr=${activeResult.lat},${
                                        activeResult.lng
                                    }`}
                                >
                                    Get directions
                                </a>
                                <a
                                    href="#"
                                    onClick={selectResult}
                                    className="infoWindow__select"
                                >
                                    Select this clinic
                                </a>
                            </p>
                        </InfoWindow>
                    )}
                </Map>
            </div>
        </div>
    );
}
